import { statusAndResponse } from "../../../../../../util/requestHandler";
import { Api, decryptApiResponse } from "../../../../../../config/Api";

export const getStatisticsInformation = (data) => {
  return statusAndResponse(
    Api.post(`api/iv/grid/statistics/verificationstatus`, data),
    decryptApiResponse,
  );
};
